import React from 'react';
import PropTypes from 'prop-types';

function GeneralButton({ onClick, type, className, children, buttonType, disabled }) {
  const buttonStyles = {
    primary: 'bg-blue-500 hover:bg-blue-400 focus:ring-blue-300',
    secondary: 'bg-gray-500 hover:bg-gray-400 focus:ring-gray-300',
    secondary_action: 'bg-gray-500 hover:bg-gray-400 focus:ring-gray-300 text-xs py-1.5',
  };
  
  const buttonClass = buttonStyles[buttonType] || buttonStyles.primary;

  return (
      <button
        type={type}
        onClick={onClick}
        className={`text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center focus:outline-none focus:ring-4 mx-2 ${buttonClass} ${className}
                            ${disabled ? 'bg-gray-400 hover:bg-gray-400 cursor-not-allowed' : 'dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'}`}
        disabled={disabled}
      >
        {children}
      </button>
  );
}

GeneralButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  buttonType: PropTypes.oneOf(['primary', 'secondary', 'secondary_action']), // Add propType for buttonType
};

GeneralButton.defaultProps = {
  type: 'button',
  className: '',
  buttonType: 'primary',
};

export default GeneralButton;
